import styled from 'styled-components';

import { media, space, rems } from '../../ui/helpers';
import fonts from '../../ui/fonts';
import { colors } from '../../ui/design-tokens';

const Module = styled.div`
  padding: ${space(4)} ${space(3)};
  background-color: ${colors.neutral[800]} !important;
  text-align: center;

  > div {
    padding: 0;
  }

  .bar {
    margin: 0 auto;
    max-width: ${rems(340)};
    width: 100%;
  }

  .title {
    ${fonts.titleMD};
    color: ${colors.neutral[100]};
    margin-bottom: ${space(4)};
  }

  .text {
    ${fonts.bodyMD};
    margin-top: ${space(2)};
  }

  a.btn {
    margin-top: ${space(2)};
    padding: 0 ${space(3)} ${space(4)} ${space(3)};
    text-decoration: none;
  }

  ${media.min('medium')`
    padding: ${space(14)} 0;

    .title {
      ${fonts.titleSM};
      margin-bottom: ${space(6)};
    }
  `}

  ${media.between('medium', 1330)`
    padding-left: ${space(3)};
    padding-right: ${space(3)};
  `}
`;

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${space(3)};
  width: 100%;

  ${media.min('medium')`
    align-items: stretch;
    flex-direction: row;
    gap: ${rems('2px')};
    justify-content: center;
  `}
`;

const Card = styled.div`
  background-color: ${colors.neutral[100]};
  max-width: ${rems(430)};
  width: 100%;

  .image {
    width: 100%;
  }

  .title {
    ${fonts.titleSM};
    color: ${colors.neutral[900]};
    margin: ${space(3)} 0;
    padding: 0 ${space(3)};
  }

  .text {
    ${fonts.bodyMD};
    margin-top: ${space(1)};
    padding: 0 ${space(3)};

    ${media.min('medium')`
      min-height: ${space(10)};
    `}
  }

  .btn {
    ${fonts.bodySM};
    color: ${colors.primary[500]};
    justify-content: left;
  }
`;

export { Module, Container, Card };
